import { buildConverseAssetImageUrl } from '@mcn-platform/converse-lib';

/**
 * Public preview image for a crawled web page (Converse CDN `/asset/thumb/webpage/{organizationID~id}`).
 */
export const getWebPageAssetImageUrl = (
  organizationID: string | null | undefined,
  webPageId: string | null | undefined,
  amplifyEnvironment: string,
): string | undefined => {
  if (!organizationID || !webPageId) return undefined;
  return buildConverseAssetImageUrl(amplifyEnvironment, 'webpage', String(organizationID), String(webPageId));
};

/**
 * When `screenshotKey` is set, returns the canonical asset URL for that page (requires org + row id).
 */
export const getScreenshotUrl = (
  screenshotKey: string | null | undefined,
  amplifyEnvironment: string,
  page?: { organizationID?: string | null; id?: string | null } | null,
): string | undefined => {
  if (!screenshotKey || typeof screenshotKey !== 'string' || !screenshotKey.startsWith('screenshot/')) {
    return undefined;
  }
  return getWebPageAssetImageUrl(page?.organizationID, page?.id, amplifyEnvironment);
};
